module.exports = __webpack_public_path__ + "img/hospitium-06.05aa22ba.jpg";